import { IS_DEMO, IS_LIVE } from "../constants";
export const appSettings = "";
export const RoutesPaths = {
  HOME: `${appSettings}/`,
  DASHBOARD: `${appSettings}/dashboard`,
  LANDING: `${appSettings}/home`,
  OLD_PAYMENT: `${appSettings}/oldpayment`,
  PAYMENT: `${appSettings}/payment`,
  PAIDUPDETAIL: `${appSettings}/payment/paidup`,
  PAIDUPDETAILPAYMENT: `${appSettings}/payment/:slug`,
  PAYMENT_BANK_TRANSFER: `${appSettings}/payment/:slug/banktransfer`,
  PAYMENT_BANK_DETAIL: `${appSettings}/payment/:slug/banktransfer/bankdetail`,
  PAYMENT_MAKEPAYMENT: `${appSettings}/payment/:slug/banktransfer/makepayment`,


  PAY_PAIDUP_PAGE_LIST: `${appSettings}/share-paid-up-capital`,
  PAY_PAIDUP_PAGE: `${appSettings}/share-paid-up-capital/:slug`,
  PAY_PAIDUP_BANKTRANSFER: `${appSettings}/share-paid-up-capital/:slug/banktransfer`,
  PAY_PAIDUP_BANKDETAIL: `${appSettings}/share-paid-up-capital/:slug/banktransfer/bankdetail`,
  PAY_PAIDUP_MAKEPAYMENT: `${appSettings}/share-paid-up-capital/:slug/banktransfer/makepayment`,


  SHARECAPITAL: `${appSettings}/share-paid-up-capital`,
  SHARECAPITALADD: `${appSettings}/share-paid-up-capital/sharecapital`,
  PAIDUPCAPITALPAY: `${appSettings}/share-paid-up-capital/sharecapital/Paid-up-capital`,
  
  FILE: `${appSettings}/file`,
  INVITE: `${appSettings}/invite`,
  TASK: `${appSettings}/task`,
  SIGNIN: `${appSettings}/`,
  SIGNUP: `${appSettings}/sign-up`,
  FORGOT_PASSWORD: `${appSettings}/forgot-password`,
  RESET_PASSWORD: `${appSettings}/reset-password/:token`,
  PROFILE: `${appSettings}/profile`,
  ACCOUNTSETTING: `${appSettings}/profile/editprofile`,
  SECURITY: `${appSettings}/security`,
  VERIFICATION: `${appSettings}/verification`,
  ADMIN_LOGIN_VERIFICATION: `${appSettings}/admin/verification/:userId/:adminId/:company`,
  INVITE_ACCEPT: `${appSettings}/promoter/:token`,
  VERIFY_EMAIL: `${appSettings}/verify-email/:token`,
  STRIPE_PAYMENT: `${appSettings}/stripe`,
  MYINFOCALLBACK: `${appSettings}/callback`,
  MESSAGE_DETAIL: `${appSettings}/chat`,
  CHAT_BOT: `${appSettings}/chat-bot`,
  BOOK_OF_BUSINESS: `${appSettings}/book-of-business`,
  BANKTRANSFER: `${appSettings}/products/:slug/banktransfer`,
  BANKDETAIL: `${appSettings}/products/:slug/banktransfer/bankdetail`,
  MAKEPAYMENT: `${appSettings}/products/:slug/banktransfer/makepayment`,
  DASHBOARD_BANKTRANSFER: `${appSettings}/dashboard/:slug/banktransfer`,
  DASHBOARD_BANKDETAIL: `${appSettings}/dashboard/:slug/banktransfer/bankdetail`,
  DASHBOARD_MAKEPAYMENT: `${appSettings}/dashboard/:slug/banktransfer/makepayment`,
  E_SIGN: `${appSettings}/e-sign`,
  SUCCESS_SIGNNOW: `${appSettings}/success-signnow`,
  PRODUCT_PAGE: `${appSettings}/products/:slug`,
  DASHBOARD_PRODUCT_PAGE: `${appSettings}/dashboard/:slug`,
  HOME_PRODUCT_PAGE: `${appSettings}/home/:slug`,
  HOME_BANKTRANSFER: `${appSettings}/home/:slug/banktransfer`,
  HOME_BANKDETAIL: `${appSettings}/home/:slug/banktransfer/bankdetail`,
  HOME_MAKEPAYMENT: `${appSettings}/home/:slug/banktransfer/makepayment`,
  PRODUCTS_LIST_PAGE: `${appSettings}/products`,
  PRODUCT_LANDING_PAGE: `${appSettings}/product-landing`,
  PRODUCT_THANK_YOU: `${appSettings}/thank-you`,
  BOOK_OF_BUSINESS_PRODUCT_PAGE: `${appSettings}/book-of-business/:slug`,
  BOOK_OF_BUSINESS_BANKTRANSFER: `${appSettings}/book-of-business/:slug/banktransfer`,
  BOOK_OF_BUSINESS_BANKDETAIL: `${appSettings}/book-of-business/:slug/banktransfer/bankdetail`,
  BOOK_OF_BUSINESS_MAKEPAYMENT: `${appSettings}/book-of-business/:slug/banktransfer/makepayment`,
  PAY_PRODUCT_PAGE: `${appSettings}/pay/:slug`,
  PAY_BANKTRANSFER: `${appSettings}/pay/:slug/banktransfer`,
  PAY_BANKDETAIL: `${appSettings}/pay/:slug/banktransfer/bankdetail`,
  PAY_MAKEPAYMENT: `${appSettings}/pay/:slug/banktransfer/makepayment`,
};
